export const OUTPUT_ADD = "@console/OUTPUT_ADD";
export const CLEAR = "@console/CLEAR";
